var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bars d-flex justify-content-between align-items-center"},_vm._l((_vm.barCount()),function(i){return _c('div',{key:i,staticClass:"bar",class:{ active: _vm.barIsActive(i) }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }